// Helper: generate time slots (15 min intervals)
export function generateTimeOptions() {
    const times = [];
    for (let hour = 0; hour < 24; hour++) {
        for (let minute = 0; minute < 60; minute += 15) {
            const hourStr = hour.toString().padStart(2, '0');
            const minuteStr = minute.toString().padStart(2, '0');
            const time = `${hourStr}:${minuteStr}`;
            times.push({
                value: time,
                label: `${hour % 12 === 0 ? 12 : hour % 12}:${minuteStr} ${hour < 12 ? 'AM' : 'PM'}`
            });
        }
    }
    return times;
}

// Helper function to get today's date
export const getTodayDate = () => new Date().toISOString().split("T")[0];

// Helper function to get future date (7 days from today)
export const getFutureDate = () => {
    const dt = new Date();
    dt.setDate(dt.getDate() + 7);
    return dt.toISOString().split("T")[0];
};

// Helper function to convert an ISO date string or backend date string to "YYYY-MM-DD" format
export const formatDateForInput = (dateStr) => {
    if (!dateStr) return "";
    // Check if the date string is in 'YYYY-MM-DD HH:mm:ss' format
    const backendDatePattern = /^\d{4}-\d{2}-\d{2} \d{2}:\d{2}:\d{2}$/;
    if (backendDatePattern.test(dateStr)) {
        // Extract only the YYYY-MM-DD part
        return dateStr.split(" ")[0];
    }
    // Fallback for other date formats
    const date = new Date(dateStr);
    if (isNaN(date.getTime())) return "";
    return date.toISOString().split("T")[0];
};